const D="GraphQL Client";const G="An error occurred while fetching from the API. Review 'graphQLErrors' for details.",J="Response returned unexpected Content-Type:",Q="An unknown error has occurred. The API did not return a data object or any errors in its response.",U={json:"application/json",multipart:"multipart/mixed"},V="X-SDK-Variant",O="X-SDK-Version",ie="shopify-graphql-client",se="1.4.1",K=1e3,ce=[429,503],Y=/@(defer)\b/i,L=`\r
`,ue=/boundary="?([^=";]+)"?/i,B=L+L;function h(r,e=D){return r.startsWith(`${e}`)?r:`${e}: ${r}`}function A(r){return r instanceof Error?r.message:JSON.stringify(r)}function X(r){return r instanceof Error&&r.cause?r.cause:void 0}function W(r){return r.flatMap(({errors:e})=>e??[])}function z({client:r,retries:e}){if(e!==void 0&&(typeof e!="number"||e<0||e>3))throw new Error(`${r}: The provided "retries" value (${e}) is invalid - it cannot be less than 0 or greater than 3`)}function p(r,e){return e&&(typeof e!="object"||Array.isArray(e)||typeof e=="object"&&Object.keys(e).length>0)?{[r]:e}:{}}function Z(r,e){if(r.length===0)return e;const n={[r.pop()]:e};return r.length===0?n:Z(r,n)}function ee(r,e){return Object.keys(e||{}).reduce((t,n)=>(typeof e[n]=="object"||Array.isArray(e[n]))&&r[n]?(t[n]=ee(r[n],e[n]),t):(t[n]=e[n],t),Array.isArray(r)?[...r]:{...r})}function te([r,...e]){return e.reduce(ee,{...r})}function de({clientLogger:r,customFetchApi:e=fetch,client:t=D,defaultRetryWaitTime:n=K,retriableCodes:o=ce}){const a=async(i,c,s)=>{const u=c+1,f=s+1;let d;try{if(d=await e(...i),r({type:"HTTP-Response",content:{requestParams:i,response:d}}),!d.ok&&o.includes(d.status)&&u<=f)throw new Error;const l=(d==null?void 0:d.headers.get("X-Shopify-API-Deprecated-Reason"))||"";return l&&r({type:"HTTP-Response-GraphQL-Deprecation-Notice",content:{requestParams:i,deprecationNotice:l}}),d}catch(l){if(u<=f){const g=d==null?void 0:d.headers.get("Retry-After");return await le(g?parseInt(g,10):n),r({type:"HTTP-Retry",content:{requestParams:i,lastResponse:d,retryAttempt:c,maxRetries:s}}),a(i,u,s)}throw new Error(h(`${s>0?`Attempted maximum number of ${s} network retries. Last message - `:""}${A(l)}`,t))}};return a}async function le(r){return new Promise(e=>setTimeout(e,r))}function fe({headers:r,url:e,customFetchApi:t=fetch,retries:n=0,logger:o}){z({client:D,retries:n});const a={headers:r,url:e,retries:n},i=me(o),c=de({customFetchApi:t,clientLogger:i,defaultRetryWaitTime:K}),s=ge(c,a),u=pe(s),f=Ae(s);return{config:a,fetch:s,request:u,requestStream:f}}function me(r){return e=>{r&&r(e)}}async function re(r){const{errors:e,data:t,extensions:n}=await r.json();return{...p("data",t),...p("extensions",n),headers:r.headers,...e||!t?{errors:{networkStatusCode:r.status,message:h(e?G:Q),...p("graphQLErrors",e),response:r}}:{}}}function ge(r,{url:e,headers:t,retries:n}){return async(o,a={})=>{const{variables:i,headers:c,url:s,retries:u,keepalive:f,signal:d}=a,l=JSON.stringify({query:o,variables:i});z({client:D,retries:u});const g=Object.entries({...t,...c}).reduce((_,[S,R])=>(_[S]=Array.isArray(R)?R.join(", "):R.toString(),_),{});return!g[V]&&!g[O]&&(g[V]=ie,g[O]=se),r([s??e,{method:"POST",headers:g,body:l,signal:d,keepalive:f}],1,u??n)}}function pe(r){return async(...e)=>{if(Y.test(e[0]))throw new Error(h("This operation will result in a streamable response - use requestStream() instead."));let t=null;try{t=await r(...e);const{status:n,statusText:o}=t,a=t.headers.get("content-type")||"";return t.ok?a.includes(U.json)?await re(t):{errors:{networkStatusCode:n,message:h(`${J} ${a}`),response:t}}:{errors:{networkStatusCode:n,message:h(o),response:t}}}catch(n){return{errors:{message:A(n),...t==null?{}:{networkStatusCode:t.status,response:t}}}}}}async function*ye(r){const e=new TextDecoder;if(r.body[Symbol.asyncIterator])for await(const t of r.body)yield e.decode(t);else{const t=r.body.getReader();let n;try{for(;!(n=await t.read()).done;)yield e.decode(n.value)}finally{t.cancel()}}}function he(r,e){return{async*[Symbol.asyncIterator](){try{let t="";for await(const n of r)if(t+=n,t.indexOf(e)>-1){const o=t.lastIndexOf(e),i=t.slice(0,o).split(e).filter(c=>c.trim().length>0).map(c=>c.slice(c.indexOf(B)+B.length).trim());i.length>0&&(yield i),t=t.slice(o+e.length),t.trim()==="--"&&(t="")}}catch(t){throw new Error(`Error occured while processing stream payload - ${A(t)}`)}}}}function be(r){return{async*[Symbol.asyncIterator](){yield{...await re(r),hasNext:!1}}}}function Ee(r){return r.map(e=>{try{return JSON.parse(e)}catch(t){throw new Error(`Error in parsing multipart response - ${A(t)}`)}}).map(e=>{const{data:t,incremental:n,hasNext:o,extensions:a,errors:i}=e;if(!n)return{data:t||{},...p("errors",i),...p("extensions",a),hasNext:o};const c=n.map(({data:s,path:u,errors:f})=>({data:s&&u?Z(u,s):{},...p("errors",f)}));return{data:c.length===1?c[0].data:te([...c.map(({data:s})=>s)]),...p("errors",W(c)),hasNext:o}})}function we(r,e){if(r.length>0)throw new Error(G,{cause:{graphQLErrors:r}});if(Object.keys(e).length===0)throw new Error(Q)}function Me(r,e){var c,s;const t=(e??"").match(ue),n=`--${t?t[1]:"-"}`;if(!((c=r.body)!=null&&c.getReader)&&!((s=r.body)!=null&&s[Symbol.asyncIterator]))throw new Error("API multipart response did not return an iterable body",{cause:r});const o=ye(r);let a={},i;return{async*[Symbol.asyncIterator](){var u;try{let f=!0;for await(const d of he(o,n)){const l=Ee(d);i=((u=l.find(b=>b.extensions))==null?void 0:u.extensions)??i;const g=W(l);a=te([a,...l.map(({data:b})=>b)]),f=l.slice(-1)[0].hasNext,we(g,a),yield{...p("data",a),...p("extensions",i),hasNext:f}}if(f)throw new Error("Response stream terminated unexpectedly")}catch(f){const d=X(f);yield{...p("data",a),...p("extensions",i),errors:{message:h(A(f)),networkStatusCode:r.status,...p("graphQLErrors",d==null?void 0:d.graphQLErrors),response:r},hasNext:!1}}}}}function Ae(r){return async(...e)=>{if(!Y.test(e[0]))throw new Error(h("This operation does not result in a streamable response - use request() instead."));try{const t=await r(...e),{statusText:n}=t;if(!t.ok)throw new Error(n,{cause:t});const o=t.headers.get("content-type")||"";switch(!0){case o.includes(U.json):return be(t);case o.includes(U.multipart):return Me(t,o);default:throw new Error(`${J} ${o}`,{cause:t})}}catch(t){return{async*[Symbol.asyncIterator](){const n=X(t);yield{errors:{message:h(A(t)),...p("networkStatusCode",n==null?void 0:n.status),...p("response",n)},hasNext:!1}}}}}}function _e({client:r,storeDomain:e}){try{if(!e||typeof e!="string")throw new Error;const t=e.trim(),n=t.match(/^https?:/)?t:`https://${t}`,o=new URL(n);return o.protocol="https",o.origin}catch(t){throw new Error(`${r}: a valid store domain ("${e}") must be provided`,{cause:t})}}function ne({client:r,currentSupportedApiVersions:e,apiVersion:t,logger:n}){const o=`${r}: the provided apiVersion ("${t}")`,a=`Currently supported API versions: ${e.join(", ")}`;if(!t||typeof t!="string")throw new Error(`${o} is invalid. ${a}`);const i=t.trim();e.includes(i)||(n?n({type:"Unsupported_Api_Version",content:{apiVersion:t,supportedApiVersions:e}}):console.warn(`${o} is likely deprecated or not supported. ${a}`))}function I(r){const e=r*3-2;return e===10?e:`0${e}`}function k(r,e,t){const n=e-t;return n<=0?`${r-1}-${I(n+4)}`:`${r}-${I(n)}`}function Se(){const r=new Date,e=r.getUTCMonth(),t=r.getUTCFullYear(),n=Math.floor(e/3+1);return{year:t,quarter:n,version:`${t}-${I(n)}`}}function Ce(){const{year:r,quarter:e,version:t}=Se(),n=e===4?`${r+1}-01`:`${r}-${I(e+1)}`;return[k(r,e,3),k(r,e,2),k(r,e,1),t,n,"unstable"]}function $e(r){return e=>({...e??{},...r.headers})}function Te({getHeaders:r,getApiUrl:e}){return(t,n)=>{const o=[t];if(n&&Object.keys(n).length>0){const{variables:a,apiVersion:i,headers:c,retries:s,signal:u}=n;o.push({...a?{variables:a}:{},...c?{headers:r(c)}:{},...i?{url:e(i)}:{},...s?{retries:s}:{},...u?{signal:u}:{}})}return o}}const q="application/json",Re="storefront-api-client",xe="1.0.9",Ie="X-Shopify-Storefront-Access-Token",De="Shopify-Storefront-Private-Token",ve="X-SDK-Variant",ke="X-SDK-Version",je="X-SDK-Variant-Source",$="Storefront API Client";function Ue(r){if(r&&typeof window<"u")throw new Error(`${$}: private access tokens and headers should only be used in a server-to-server implementation. Use the public API access token in nonserver environments.`)}function Ne(r,e){if(!r&&!e)throw new Error(`${$}: a public or private access token must be provided`);if(r&&e)throw new Error(`${$}: only provide either a public or private access token`)}function Pe({storeDomain:r,apiVersion:e,publicAccessToken:t,privateAccessToken:n,clientName:o,retries:a=0,customFetchApi:i,logger:c}){const s=Ce(),u=_e({client:$,storeDomain:r}),f={client:$,currentSupportedApiVersions:s,logger:c};ne({...f,apiVersion:e}),Ne(t,n),Ue(n);const d=Fe(u,e,f),l={storeDomain:u,apiVersion:e,...t?{publicAccessToken:t}:{privateAccessToken:n},headers:{"Content-Type":q,Accept:q,[ve]:Re,[ke]:xe,...o?{[je]:o}:{},...t?{[Ie]:t}:{[De]:n}},apiUrl:d(),clientName:o},g=fe({headers:l.headers,url:l.apiUrl,retries:a,customFetchApi:i,logger:c}),b=$e(l),_=Ve(l,d),S=Te({getHeaders:b,getApiUrl:_});return Object.freeze({config:l,getHeaders:b,getApiUrl:_,fetch:(...C)=>g.fetch(...S(...C)),request:(...C)=>g.request(...S(...C)),requestStream:(...C)=>g.requestStream(...S(...C))})}function Fe(r,e,t){return n=>{n&&ne({...t,apiVersion:n});const o=(n??e).trim();return`${r}/api/${o}/graphql.json`}}function Ve(r,e){return t=>t?e(t):r.apiUrl}const v=`#graphql
fragment Media on Media {
  __typename
  mediaContentType
  alt
  previewImage {
    url
  }
  ... on MediaImage {
    id
    image {
      url
      width
      height
    }
  }
  ... on Video {
    id
    sources {
      mimeType
      url
    }
  }
  ... on Model3d {
    id
    sources {
      mimeType
      url
    }
  }
  ... on ExternalVideo {
    id
    embedUrl
    host
  }
}
`,P=`#graphql
  fragment Metaobject on Metaobject {
    id
    handle
    type
    fields {
      key
      type
      value
      reference {
        ... on GenericFile {
          id
          url
          mimeType
        }
        ... on Media {
          ...Media
        }
        ... on Metaobject {
          ...InnerMetaobject
        }
      }
      references(first: 250) {
        nodes {
          ... on Metaobject {
            ...InnerMetaobject
          }
        }
      }
    }
  }
`,F=`#graphql
  fragment InnerMetaobject on Metaobject {
    id
    handle
    type
    fields {
      key
      type
      value
      reference {
        ... on GenericFile {
          id
          url
          mimeType
        }
        ... on Media {
          ...Media
        }
        ... on Metaobject {
          id
          handle
          type
          fields {
            key
            type
            value
            reference {
              ...Media
            }
          }
        }
      }
      references(first: 250) {
        nodes {
          ... on GenericFile {
            id
            url
            mimeType
          }
          ... on Media {
            ...Media
          }
          ... on Metaobject {
            id
            handle
            type
            fields {
              key
              type
              value
              reference {
                ... on GenericFile {
                  id
                  url
                  mimeType
                }
                ... on Media {
                  ...Media
                }
                ... on Metaobject {
                  id
                  handle
                  type
                  fields {
                    key
                    type
                    value
                  }
                }
              }
              references(first: 250) {
                nodes {
                  ... on GenericFile {
                    id
                    url
                    mimeType
                  }
                  ... on Media {
                    ...Media
                  }
                  ... on Metaobject {
                    id
                    handle
                    type
                    fields {
                      key
                      type
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`,Oe=`#graphql
  ${v}
  ${P}
  ${F}
  query metaobjects(
    $numLimit: Int!,
    $cursor: String,
    $type: String!,
    $country: CountryCode,
    $language: LanguageCode
  ) @inContext(
    country: $country,
    language: $language
  ) {
    metaobjects(first: $numLimit, after: $cursor, type: $type) {
      nodes {
        id
        handle
        type
        fields {
          key
          type
          value
          reference {
            ... on Metaobject {
              ...Metaobject
            }
            ... on GenericFile {
              id
              url
              mimeType
            }
            ... on Media {
              ...Media
            }
          }
          references(first: 250) {
            nodes {
              ... on Metaobject {
                ...Metaobject
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`,Le=`#graphql
  ${v}
  ${P}
  ${F}
  query metaobjectById(
    $id: ID,
    $country: CountryCode,
    $language: LanguageCode
  ) @inContext(
    country: $country,
    language: $language
  ) {
    metaobject(id: $id) {
      id
      handle
      type
      fields {
        key
        type
        value
        reference {
          ... on Metaobject {
            ...Metaobject
          }
        }
        references(first: 250) {
          nodes {
            ... on Metaobject {
              ...Metaobject
            }
          }
        }
      }
    }
  }
`,Be=`#graphql
  ${v}
  query mediaById(
    $id: ID!
  ) {
    node(id: $id) {
      ... on MediaImage {
        ...Media
      }
    }
  }
`,qe=()=>{var a;const t=(a=window.Shopify)==null?void 0:a.shop;let n="",o="";switch(t){case"mymuesli-dev.myshopify.com":n="e1b1a18b200d8096f9a767852b20320b",o="7b716bf926dff9462574";break;case"mymuesli-test.myshopify.com":n="8ac0ecb3029cffda27d06dd0ad3ade63",o="7b716bf926dff9462574";break;case"mymuesli-prod.myshopify.com":n="148071bd7ceb7b42051cf185ef49884d",o="e03be71aaf0aff3e6680";break;case"mymuesli-b2b.myshopify.com":n="8cfec8a8934526bd2cc8d177e19c5485",o="e03be71aaf0aff3e6680";break;case"mymuesli-ch-test.myshopify.com":n="1c140f5fde2e4f0bea57dc7cc7d885fc",o="7b716bf926dff9462574";break;case"mymuesli-ch-prod.myshopify.com":n="80c6148cbe40627d46299255c603e889",o="e03be71aaf0aff3e6680";break;case"mymuesli-patrick-dev.myshopify.com":n="6b92d1eb9cdbacb8286790a431fed193",o="7b716bf926dff9462574";break;case"stephdev-2.myshopify.com":n="b36effbf1db6716d62b447dece1aa9f3",o="7b716bf926dff9462574";break;case"dev-store-volker.myshopify.com":n=void 0,o="7b716bf926dff9462574";break}return{isDevelopment:!1,isProduction:!0,apiBaseUrl:"/apps/app-proxy",storefrontDomain:t,storefrontAccessToken:n,storefrontApiVersion:"2025-04",uploadcarePublicKey:o}},w=qe(),He=`#graphql
  query metafields(
    $country: CountryCode,
    $language: LanguageCode
  ) @inContext(
    country: $country,
    language: $language
  ) {
    shop {
      mixerValidations: metafield(
        namespace: "custom",
        key: "mixer_validations"
      ) {
        id
        namespace
        key
        value
        type
      }
      designValidations: metafield(
        namespace: "custom",
        key: "design_validations"
      ) {
        id
        namespace
        key
        value
        type
      }
      ingredientValidations: metafield(
        namespace: "custom",
        key: "ingredient_validations"
      ) {
        id
        namespace
        key
        value
        type
      }
      mixerConfiguration: metafield(
        namespace: "custom",
        key: "mixer_configuration"
      ) {
        id
        namespace
        key
        value
        type
      }
      mixerBioLogo: metafield(
        namespace: "custom",
        key: "mixer_bio_logo"
      ) {
        id
        namespace
        key
        value
        type
        reference {
          ... on MediaImage {
            id
            image {
              url
              altText
            }
            mediaContentType
            alt
          }
        }
      }
      ingredientValidationsDebug: metafield(
        namespace: "custom",
        key: "ingredient_validations_debug"
      ) {
        id
        namespace
        key
        value
        type
      }
      mixerCustomMixProduct: metafield(
        namespace: "custom",
        key: "mixer_custom_mix_product"
      ) {
        id
        namespace
        key
        value
        type
        reference {
          ... on Product {
            id
            title
            variants(first: 1) {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
      mixerBadwords: metafield(
        namespace: "custom",
        key: "mixer_badwords"
      ) {
        id
        namespace
        key
        value
        type
      }
    }
  }
`,Ge=`#graphql
  ${v}
  ${P}
  ${F}
  query metaobjectByHandle(
    $handle: MetaobjectHandleInput,
    $country: CountryCode,
    $language: LanguageCode
  ) @inContext(
    country: $country,
    language: $language
  ) {
    metaobject(handle: $handle) {
      id
      handle
      type
      fields {
        key
        type
        value
        reference {
          ... on Metaobject {
            ...Metaobject
          }
        }
        references(first: 250) {
          nodes {
            ... on Metaobject {
              ...Metaobject
            }
          }
        }
      }
    }
  }
`,m=[];for(let r=0;r<256;++r)m.push((r+256).toString(16).slice(1));function Je(r,e=0){return(m[r[e+0]]+m[r[e+1]]+m[r[e+2]]+m[r[e+3]]+"-"+m[r[e+4]]+m[r[e+5]]+"-"+m[r[e+6]]+m[r[e+7]]+"-"+m[r[e+8]]+m[r[e+9]]+"-"+m[r[e+10]]+m[r[e+11]]+m[r[e+12]]+m[r[e+13]]+m[r[e+14]]+m[r[e+15]]).toLowerCase()}let j;const Qe=new Uint8Array(16);function Ke(){if(!j){if(typeof crypto>"u"||!crypto.getRandomValues)throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");j=crypto.getRandomValues.bind(crypto)}return j(Qe)}const Ye=typeof crypto<"u"&&crypto.randomUUID&&crypto.randomUUID.bind(crypto),H={randomUUID:Ye};function Xe(r,e,t){var o;if(H.randomUUID&&!r)return H.randomUUID();r=r||{};const n=r.random??((o=r.rng)==null?void 0:o.call(r))??Ke();if(n.length<16)throw new Error("Random bytes length must be >= 16");return n[6]=n[6]&15|64,n[8]=n[8]&63|128,Je(n)}class We{static generateUuid(){return Xe()}static async generateMixUid(e,t=12){const n=Math.min(t,12),o=typeof e=="string"?e:JSON.stringify(e),a=JSON.stringify(JSON.parse(o)),c=new TextEncoder().encode(a),s=await crypto.subtle.digest("SHA-256",c),u=Array.from(new Uint8Array(s)),d=btoa(String.fromCharCode.apply(null,u)).replace(/[+/=]/g,l=>l==="+"?"-":l==="/"?"_":"");return this.sanitizeToSafeAlphanumeric(d.substring(0,n))}static sanitizeToSafeAlphanumeric(e){const t="ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789",n=/[^a-zA-Z0-9]|[oO0Il1]/g;return e.replace(n,()=>t.charAt(Math.floor(Math.random()*t.length)))}static generateTimestampId(e=""){const t=Date.now(),n=Math.random().toString(36).substring(2,8);return`${e}${t}_${n}`}static generateRandomId(e=8){const t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";let n="";for(let o=0;o<e;o++)n+=t.charAt(Math.floor(Math.random()*t.length));return n}static isValidUuid(e){return/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(e)}static isValidMixUid(e){return!!(e&&e.length===12&&/^[A-Za-z0-9_-]+$/.test(e))}}class ze{static convertToGrams(e,t){if(!t)return 0;const n=t.toLowerCase();return/kg|kilogram(s)/.test(n)?e*1e3:/g|gram(s)/.test(n)?e:0}static formatUnit(e){const t=e.toLowerCase();return/^g|gram|grams$/i.test(t)?"g":/^kg|kilogram|kilograms$/i.test(t)?"kg":e}static formatWeight(e,t="g"){return`${e} ${this.formatUnit(t)}`}static isValidWeight(e,t,n){return e>=t&&e<=n}static calculateTotalWeight(e){return e.reduce((t,n)=>t+n,0)}}class oe{static encodeConfigurationPayload(e){const t=JSON.stringify(e);return btoa(t).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"")}static decodeConfigurationPayload(e){let t=e.replace(/-/g,"+").replace(/_/g,"/");for(;t.length%4;)t+="=";const n=atob(t);return JSON.parse(n)}static encodeToBase64(e){const t=JSON.stringify(e);return btoa(t).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"")}static decodeFromBase64(e){let t=e.replace(/-/g,"+").replace(/_/g,"/");for(;t.length%4;)t+="=";const n=atob(t);return JSON.parse(n)}static isValidConfigurationPayload(e){try{const t=this.decodeConfigurationPayload(e);return t&&typeof t=="object"}catch{return!1}}}class Ze{static async fetchMyMuesliApi(e,t){const n=w.apiBaseUrl;try{const o=await fetch(`${n}/${e}`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(t)}),a=await o.json();return o.status!==200&&w.isDevelopment&&console.error("[MyMuesli API] 1 Error fetching data",a),{result:o.status===200?a:null,status:o.status,error:o.status!==200?a:null}}catch(o){return w.isDevelopment&&console.error("[MyMuesli API] 2 Error fetching data",o),{result:null,status:500,error:o}}}static async fetchMixConfiguration(e){try{const t=await this.fetchMyMuesliApi("custommixconfiguration",{mix_uid:e});return t.status===200?t.result.mix_configuration:(console.error(t.error),null)}catch(t){return console.error("Error fetching mix configuration:",t),null}}static async fetchIngredientsDeclaration(e,t,n){try{const o=await this.fetchMyMuesliApi("listofingredients",{ingredients:e,localeIdentifier:`${t.toLowerCase()||"de"}_${n.toUpperCase()||"DE"}`});if(o.error)throw o.error;return o.result}catch(o){return console.error("Error fetching ingredients declaration:",o),null}}static async fetchNutritionData(e,t,n){try{const o=await this.fetchMyMuesliApi("nutritions",{ingredients:e,perGram:"100",localeIdentifier:`${t.toLowerCase()||"de"}_${n.toUpperCase()||"DE"}`});if(o.error)throw o.error;return o.result}catch(o){return console.error("Error fetching nutrition data:",o),null}}static async fetchFlavorProfile(e){try{const t=await this.fetchMyMuesliApi("flavor",{ingredients:e});if(t.error)throw t.error;return t.result}catch(t){return console.error("Error fetching flavor profile:",t),null}}static async fetchAdditionalHints(e,t,n){try{const o=await this.fetchMyMuesliApi("additionalhints",{ingredients:e,localeIdentifier:`${t.toLowerCase()||"de"}_${n.toUpperCase()||"DE"}`});if(o.error)throw o.error;return o.result.additionalHints}catch(o){return console.error("Error fetching additional hints:",o),null}}static async fetchAllExternalApiData(e,t,n){const[o,a,i,c]=await Promise.all([this.fetchIngredientsDeclaration(e,t,n),this.fetchFlavorProfile(e),this.fetchNutritionData(e,t,n),this.fetchAdditionalHints(e,t,n)]);return{ingredientsDeclaration:o,flavour:a,nutrition:i,additionalHints:c}}}const x={language:"DE",country:"DE"},T=Pe({storeDomain:w.storefrontDomain,apiVersion:w.storefrontApiVersion,publicAccessToken:w.storefrontAccessToken});async function et(r,e,t){var o;return(o=(await T.request(Le,{variables:{id:r,country:e,language:t}})).data)==null?void 0:o.metaobject}async function tt(r,e,t){var o;return(o=(await T.request(Ge,{variables:{handle:r,country:e,language:t}})).data)==null?void 0:o.metaobject}async function N(r="",{list:e=[],cursor:t=void 0,numLimit:n=250,country:o="DE",language:a="DE"}={}){var i,c,s;try{const u=await T.request(Oe,{variables:{numLimit:n,type:r,country:o,language:a,cursor:t}}),f=((i=u.data)==null?void 0:i.metaobjects.pageInfo.hasNextPage)||!1,d=((c=u.data)==null?void 0:c.metaobjects.pageInfo.endCursor)||void 0,l=((s=u.data)==null?void 0:s.metaobjects.nodes)||[];return e=[...e,...l],f?await N(r,{list:e,cursor:d,numLimit:n,country:o,language:a}):e}catch(u){return console.error("Error fetching ingredients",u),[]}}const E=r=>{if(!r)return r;try{return JSON.parse(r)}catch{return r}},rt=r=>{var e;return((e=r.references)==null?void 0:e.nodes.map(t=>{if("fields"in t){const n={...M(t.fields),id:t.id};return Object.entries(n).reduce((a,[i,c])=>(c&&typeof c=="object"?"fields"in c?a[i]={...M(c.fields),id:c.id}:Array.isArray(c)?a[i]=c.map(s=>s&&typeof s=="object"&&"fields"in s?{...M(s.fields),id:s.id}:s):a[i]=c:a[i]=c,a),{})}else return t}))||[]},nt=r=>r.reference||r.value;function M(r){return r.reduce((e,t)=>{let n;switch(t.type){case"boolean":n=typeof t.value=="boolean"?t.value:typeof t.value=="string"?t.value==="true":t.value;break;case"color":n=t.value;break;case"date":n=t.value;break;case"date_time":n=t.value;break;case"dimension":n=E(t.value),"value"in n&&(n.value=y(n.value));break;case"id":n=t.value;break;case"json":n=E(t.value);break;case"link":n=E(t.value);break;case"money":n=E(t.value),"amount"in n&&(n.amount=y(n.amount));break;case"multi_line_text_field":n=t.value;break;case"number_decimal":n=y(t.value);break;case"number_integer":n=y(t.value);break;case"rating":n=E(t.value),"value"in n&&(n.value=y(n.value)),"scale_min"in n&&(n.value=y(n.value)),"scale_max"in n&&(n.value=y(n.value));break;case"rich_text_field":n=t.value;break;case"single_line_text_field":n=t.value;break;case"url":n=t.value;break;case"volume":n=E(t.value),"value"in n&&(n.value=y(n.value));break;case"weight":n=E(t.value),"value"in n&&(n.value=y(n.value));break;default:t.reference?n=nt(t):t.references?n=rt(t):n=t.value;break}return e[t.key]=n,e},{})}function y(r){if(typeof r=="number")return r;if(typeof r=="string"){const e=parseFloat(r);return Number.isNaN(e)?0:e}if(typeof r=="boolean")return r?1:0;if(r==null)return 0;try{const e=String(r),t=parseFloat(e);return Number.isNaN(t)?0:t}catch{return 0}}function ot(r){return r.map(e=>M(e.fields))}function at(r){return r.map(e=>M(e.fields))}function it(r){return M((r==null?void 0:r.fields)||[])}const ft=Ze.fetchMyMuesliApi;async function mt(r,e=20){var n;let t=0;for(;t<e;)try{const a=(n=(await T.request(Be,{variables:{id:r}})).data)==null?void 0:n.node;if(a)return t>0&&console.log(`Media image fetched successfully on attempt ${t+1}`),a;if(t<e-1)t++,console.log(`Media image fetch returned null, retrying... (attempt ${t+1}/${e})`),await new Promise(i=>setTimeout(i,1e3));else{console.warn(`Media image fetch failed after ${e} attempts - result was null`);return}}catch(o){console.error(`Error fetching media image on attempt ${t+1}:`,o);return}}function st(r){if(typeof r=="string")try{return JSON.parse(r)}catch(e){console.error("Failed to parse liquid data:",e)}return{bioLogoSrc:"",stickerSrc:"",fonts:{},baseModelSrc:"",customerId:"",i18n:{language:x.language,country:x.country,locale:`${x.language}_${x.country}`,translations:{}},configuration:"",decodedConfiguration:void 0,product:null,variant:null}}async function ct(r,e){var o;const t=await T.request(He,{variables:{country:r,language:e}}),n={};return Object.entries(((o=t.data)==null?void 0:o.shop)||{}).forEach(([a,i])=>{(i==null?void 0:i.type)==="json"&&(i.value=JSON.parse(i.value||"{}")),i!=null&&i.value&&(a==="mixerValidations"||a==="ingredientValidations"||a==="ingredientValidationsDebug"||a==="designValidations"?n[a]=i.value.validations:i!=null&&i.type.endsWith("_reference")&&"reference"in i&&(i!=null&&i.reference)?n[a]=i.reference:n[a]=i.value)}),n}async function ut(r,e,t,n){let o,a=null;if(r)try{a=await tt({type:"mixer_configuration",handle:r},t,n)}catch(s){console.error("Failed to fetch mixer configuration:",s)}else{const s=e.mixerConfiguration;try{a=await et(s,t,n)}catch(u){console.error("Failed to fetch mixer configuration:",u)}}if(!a)return{mixerConfiguration:null,ingredientFilters:[],ingredientUSPs:[]};o={...it(a),handle:a.handle};const i=await N("ingredient_filter",{country:t,language:n}).then(s=>ot(s)),c=await N("usp",{country:t,language:n}).then(s=>at(s));return{mixerConfiguration:o,ingredientFilters:i,ingredientUSPs:c}}async function gt(r,e){var s;const t=new URLSearchParams(window.location.search),n=st(r);let o=null;n.configuration&&(o=dt(n.configuration),n.decodedConfiguration=o,!e&&((s=o==null?void 0:o.configuration)!=null&&s.mixer_configuration_handle)&&(e=o.configuration.mixer_configuration_handle));const a=await ct(n.i18n.country,n.i18n.language),i=await ut(e,a,n.i18n.country,n.i18n.language);if(!i.mixerConfiguration)if(t.get("instance")){const u=new URL(window.location.href);u.searchParams.delete("instance"),window.location.href=u.toString()}else window.location.href="/404";const c=window.location.search.includes("debug")&&new URLSearchParams(window.location.search).get("debug")==="1";return{mixerCustomMixProduct:a.mixerCustomMixProduct,mixerBioLogo:a.mixerBioLogo,mixerValidations:a.mixerValidations,ingredientValidations:c?a.ingredientValidationsDebug:a.ingredientValidations,designValidations:a.designValidations,mixerConfiguration:i.mixerConfiguration,ingredientFilters:i.ingredientFilters,ingredientUSPs:i.ingredientUSPs,mixerBadwords:a.mixerBadwords,liquidData:n}}const pt=oe.encodeConfigurationPayload,dt=oe.decodeConfigurationPayload;function ae(r){return window.themeVendor.themeCurrency.formatMoney(r,window.theme.moneyFormat)}const lt=ze.formatUnit;function yt(r){const{price:e}=r,t=e.amount*100;return ae(t)}function ht(r){var t;let e=((t=r.reduced_from_price)==null?void 0:t.amount)*100;return e>0?ae(e):""}function bt(r){var e,t,n;return((e=r.reduced_from_price)==null?void 0:e.amount)>0&&((t=r.reduced_from_price)==null?void 0:t.amount)>((n=r.price)==null?void 0:n.amount)}function Et(r){const{weight:e}=r;return typeof e=="object"&&e.value&&e.unit?`${e.value} ${lt(e.unit)}`:`${e} g`}function wt(){return We.generateUuid()}function Mt(r){return String(r).replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/'/g,"&#39;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}function At(r=10,e=500){return new Promise((t,n)=>{let o=0;const a=()=>{if(o++,"MyMuesli"in window&&window.MyMuesli.storage){t(window.MyMuesli.storage);return}if(o>=r){console.error(`MyMuesli storage service not available after ${r} attempts`),n(null);return}setTimeout(a,e)};a()})}function _t(r,e=0){let t;return typeof r=="string"?t=parseFloat(r):t=r,parseFloat(t.toFixed(e))}function St(r,e){let t=null;return(...n)=>{t&&clearTimeout(t),t=setTimeout(()=>r(...n),e)}}export{Ze as A,oe as E,We as I,ze as W,mt as a,gt as b,ae as c,dt as d,pt as e,tt as f,_t as g,w as h,St as i,ft as j,bt as k,yt as l,ht as m,Et as n,wt as o,Mt as p,At as w};
